// Module
var code = "<div class=\"grid_division\"> <div class=\"main_grid\"> <div> <div class=\"mishion_history\"> <div class=\"mission_title\">Part Orders</div> </div> <div class=\"text-right\"> <a class=\"btn btn-secondary\" ui-sref=\"^.ordersAdd\" if-has-permissions=\"'partOrderAdd'\"> <span> <i class=\"fa fa-plus\"></i> ADD ORDER </span> </a> </div> <part-orders-grid> </part-orders-grid> </div> </div> </div>";
// Exports
var _module_exports = code;;
var path = 'parts/Pages/orders/index.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;